import { useContext } from 'react';
import classnames from 'classnames';

import { ChatikContext } from '@hh.ru/chatik-integration';
import { HSpacing } from '@hh.ru/magritte-ui';
import { BubbleRoundFilledSize16 } from '@hh.ru/magritte-ui/icon';
import { TranslatedComponent } from 'bloko/common/hooks/useTranslations';
import { format } from 'bloko/common/trl';

import VerticallyCentredIconSize16 from 'src/components/VerticallyCentredIconSize16';
import translation from 'src/components/translation';
import { useIsZarplataPlatform } from 'src/hooks/usePlatform';
import { useSelectorNonNullable, useSelector } from 'src/hooks/useSelector';
import { UserType } from 'src/models/userType';

import styles from './styles.less';

const TrlKeys = {
    activator: 'vacancyresponse.chatik.activatorWithDomain',
};

interface Props {
    topicId: string;
    markAsRead?: () => void;
    onContactsClick?: () => void;
}

const ChatikDeepLink: TranslatedComponent<Props> = ({ topicId, markAsRead, onContactsClick, trls }) => {
    const openChatik = useContext(ChatikContext)?.openChatik;
    const chatId = useSelectorNonNullable((state) => state.candidatesList.shortTopicList?.topicList[topicId].chatId);

    const isZP = useIsZarplataPlatform();
    const topLevelDomain = useSelector((state) => state.topLevelDomain || 'hh.ru');
    const isBackoffice = useSelector((state) => state.userType === UserType.BackOffice);

    if (isBackoffice) {
        return null;
    }

    return (
        <span
            className={styles.chatikDeepLink}
            onClick={() => {
                markAsRead?.();
                openChatik?.({ chatId, view: 'compact', hhtmFromLabel: 'employer_vacancy_responses_chat_link' });
                onContactsClick?.();
            }}
            data-interactive
            data-qa={classnames('resume-card-deep-link', 'resume-card-deep-link_chatik')}
        >
            <VerticallyCentredIconSize16 icon={<BubbleRoundFilledSize16 initialColor="tertiary" />} />
            <HSpacing default={4} />
            {format(trls[TrlKeys.activator], {
                // у зарплаты в topLevelDomain - hr.zarplata.ru
                '{0}': isZP ? 'zarplata.ru' : topLevelDomain,
            })}
        </span>
    );
};

export default translation(ChatikDeepLink);
